import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import defaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const YandexPopup = styled(defaultPopup)``;

export const Container = styled.div`
  display: flex;
  max-width: 664px;
  width: 100%;
  padding: 40px 60px 32px 60px;
  flex-direction: column;

  @media (max-width: 640px) {
    padding: 40px 20px;
  }
`;

export const Title = styled.div`
  ${FONTS.M};
  font-size: 24px;
  line-height: 1.16;
`;

export const Text = styled.div`
  display: inline-block;
  ${FONTS.XS};
  font-size: 16px;
  line-height: 1.5em;
  margin: 24px 0;
`;

export const Button = styled(BaseButton)`
  min-width: 221px;
  font-size: 16px;
  line-height: 20px;
  width: fit-content;
`;
